/**
 * 动态排名折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicRankingLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'date', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'dynamic-ranking-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: 'Dynamic ranking line requires more than 1 data point',
      suggestion: 'Provide multiple data points for ranking visualization',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-ranking-unique-x-values',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(data)) {
          return false;
        }
        const xValues = new Set(data.map(item => item[encoding?.x as string] as string));
        return xValues.size > 2;
      },
      message: 'Dynamic ranking line requires more than 2 unique x values',
      suggestion: 'Provide more time points for meaningful ranking changes',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-ranking-unique-y-values',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(data)) {
          return false;
        }
        const yValues = new Set(data.map(item => item[encoding?.y as string] as number));
        return yValues.size > 1;
      },
      message: 'Dynamic ranking line requires more than 1 unique y value',
      suggestion: 'Ensure data has varying y values for ranking visualization',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'dynamic-ranking-sufficient-categories',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(data)) {
          return false;
        }
        const zValues = new Set(data.map(item => item[encoding?.z as string] as string));
        return zValues.size > 3;
      },
      message: 'Dynamic ranking line works best with more than 3 unique categories',
      suggestion: 'Provide at least 4 categories for better ranking visualization',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
